import styled from '@emotion/styled';

import _WaitIcon from '@/assets/icons/icon_wait.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const WaitIcon = styled.i(() =>
  mq({
    display: 'block',
    width: ['24px', '24px', '32px', '32px'],
    height: ['24px', '24px', '32px', '32px'],
    backgroundImage: `url(${_WaitIcon})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    margin: '0 auto',
  }),
);

export const Wrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& > div:not(:last-child)': {
      marginBottom: defaultTheme.spacing.s,
    },
    '& > span:not(:last-child)': {
      marginBottom: [
        defaultTheme.spacing.xs,
        defaultTheme.spacing.xs,
        defaultTheme.spacing.s,
        defaultTheme.spacing.s,
      ],
    },
  }),
);
